import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const FixedAssetList = () => {
  const fields = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <NewCatalogListView fields={fields} entity={AppEntities.FixedAsset} />
    </>
  );
};

export default FixedAssetList;
